"use strict";

$.widget("fotobook.calendarFontSizeBaseWidget", $.fotobook.fontSizeBaseWidget, {
    _styleCssSelector: null,
    _getValueFromProject: function(){
        var fontSize = parseInt(this.getContainer().attr("data-" + this.options.attribute), 10);

        this.input.numberInput("value", this._fsPx2Num(fontSize));
    },
    _setPreviewStyle: function(fontSize){
        var fields = {},
            fsPx = this._fsNum2Px(fontSize);

        fields[this.options.attribute] = fsPx;
        this._styleCssSelector = Fotobook.containers.calendar.style.addOverride(this.getContainer(), this.options.template, fields, this._styleCssSelector);
    },
    _removePreviewStyle: function(){
        Fotobook.containers.calendar.style.removeOverride(this._styleCssSelector);
    },
    _changeFontSize(fontSize){
        Fotobook.containers.calendar.changeAttribute(this.getContainer(), this.options.attribute, this._fsNum2Px(fontSize)).catch(
            () => {}
        ).finally(() => {
            this._removePreviewStyle();
        });
    },
});

$.widget("fotobook.calendarFontSizeHeaderWidget", $.fotobook.calendarFontSizeBaseWidget, {
    "options" : {
        "attribute" : "month_font_size",
        "template" : "monthFontSize",
    },
    _checkEnabled: function(){
        return Fotobook.containers.calendar.headerIsVisible(this.getContainer());
    },
});

$.widget("fotobook.calendarFontSizeRegularWidget", $.fotobook.calendarFontSizeBaseWidget, {
    "options" : {
        "attribute" : "numbers_font_size",
        "template" : "numbersFontSize",
    },
});

$.widget("fotobook.calendarFontSizeHolidayTitleWidget", $.fotobook.calendarFontSizeBaseWidget, {
    "options" : {
        "attribute" : "numbers_title_font_size",
        "template" : "numbersTitleFontSize",
    },
    _checkEnabled: function(){
        return Fotobook.containers.calendar.holidayTitlesAreVisible(this.getContainer());
    },
});

$.widget("fotobook.calendarFontSizeDayNamesWidget", $.fotobook.calendarFontSizeBaseWidget, {
    "options" : {
        "attribute" : "day_name_font_size",
        "template" : "dayNameFontSize",
    },
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.getContainer());
    },
});

$.widget("fotobook.calendarFontSizeWeekNumbersWidget", $.fotobook.calendarFontSizeBaseWidget, {
    "options" : {
        "attribute" : "week_numbers_font_size",
        "template" : "weekNumbersFontSize",
    },
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.getContainer());
    },
});

